import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { roleGuard } from './core/guards/role.guard';
import { authorizationReadyGuard } from './core/authorization/authorization-ready.guard';
import { Permissions } from './core/authorization/permissions';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./layout/main-layout/main-layout.component').then(m => m.MainLayoutComponent),
    canActivate: [authGuard, authorizationReadyGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent),
        title: 'Home - Shrivitech'
      },
      {
        path: 'users',
        loadComponent: () => import('./features/users/users.component').then(m => m.UsersComponent),
        canActivate: [roleGuard(Permissions.users.list)],
        title: 'Users - Shrivitech'
      },
      {
        path: 'roles',
        loadComponent: () => import('./features/roles/roles.component').then(m => m.RolesComponent),
        canActivate: [roleGuard(Permissions.system.manageRoles)],
        title: 'Roles - Shrivitech'
      },
      {
        path: 'audit',
        loadComponent: () => import('./features/audit/audit.component').then(m => m.AuditComponent),
        canActivate: [roleGuard(Permissions.system.viewLogs)],
        title: 'Audit Logs - Shrivitech'
      },
      {
        path: 'settings',
        loadComponent: () => import('./features/settings/settings.component').then(m => m.SettingsComponent),
        canActivate: [roleGuard(Permissions.system.manageSettings)],
        title: 'Settings - Shrivitech'
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/profile/profile.component').then(m => m.ProfileComponent),
        title: 'Profile - Shrivitech'
      },
      {
        path: 'card-arena',
        loadComponent: () =>
          import('./features/card-arena/dashboard/card-arena-dashboard.component').then(
            m => m.CardArenaDashboardComponent
          ),
        canActivate: [roleGuard(Permissions.system.manageSettings)],
        title: 'Card Arena - Shrivitech'
      },
      {
        path: 'card-arena/manage/:key',
        loadComponent: () =>
          import('./features/card-arena/crud/card-arena-crud.component').then(m => m.CardArenaCrudComponent),
        canActivate: [roleGuard(Permissions.system.manageSettings)],
        title: 'Card Arena Catalog - Shrivitech'
      },
      {
        path: 'card-arena/monetization',
        loadComponent: () =>
          import('./features/card-arena/monetization/monetization.component').then(
            m => m.MonetizationComponent
          ),
        canActivate: [roleGuard(Permissions.ads.manage)],
        title: 'Card Arena Monetization - Shrivitech'
      }
    ]
  },
  {
    path: '',
    loadComponent: () => import('./layout/blank-layout/blank-layout.component').then(m => m.BlankLayoutComponent),
    children: [
      {
        path: 'login',
        loadComponent: () => import('./features/auth/login/login.component').then(m => m.LoginComponent),
        title: 'Login - Shrivitech'
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./features/auth/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent),
        title: 'Forgot Password - Shrivitech'
      },
      {
        path: 'reset-password',
        loadComponent: () => import('./features/auth/reset-password/reset-password.component').then(m => m.ResetPasswordComponent),
        title: 'Reset Password - Shrivitech'
      },
      {
        path: 'access-denied',
        loadComponent: () => import('./features/auth/access-denied/access-denied.component').then(m => m.AccessDeniedComponent),
        canActivate: [authGuard],
        title: 'Access Denied - Shrivitech'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
